import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { publicApi } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export const OfferBanner = ({ token }) => {
  const [offers, setOffers] = useState([]);
  useEffect(() => { publicApi.get(`/${token}/offers`).then((r) => setOffers(r.data)).catch(() => {}); }, [token]);
  return offers.map((o) => (
    <div key={o.id} className="mt-4 flex gap-3 rounded-2xl bg-gradient-to-r from-[#D96B43] to-[#F2B880] p-4 text-white shadow-md" data-testid={`portal-offer-${o.id}`}>
      <PartyPopper className="h-6 w-6 shrink-0" />
      <div><div className="font-display font-bold">{o.festival} special</div><div className="text-sm">{o.offer_text}</div><div className="mt-1 text-xs opacity-90">Valid till {fmtDate(o.end_date)}</div></div>
    </div>
  ));
};
